/**
 * 현장 통계(근로자·재해발생 현황) 타입.
 *
 * 여기 있는 것은 현장 생성/상세(사업개요 탭)가 읽는 8개다 — 양식 전용 타입·상수는 두지 않고,
 * 위험성평가 기준표(`RiskAssessmentConfig`·`RiskAssessmentMethodType`)는 축이 달라
 * `types/risk-assessment-config.ts`에 있다.
 */

/**
 * 범용 근로자 현황 — 카테고리를 보고서 타입별로 정의
 * 안전관리상태보고서: [{key:'office',count:N},{key:'nonOffice',count:N}]
 * 다른 보고서: [{key:'male',count:N},{key:'female',count:N},...] 등
 */
export interface WorkerStatsEntry {
  id?: string;                   // DB PK (서버 응답에 포함)
  periodValue: string;           // "2025", "2026"
  categories: WorkerCategory[];
}

export interface WorkerCategory {
  key: string;                   // 카테고리 식별자
  count: number;
}

/** 컴포넌트에 전달할 카테고리 설정 */
export interface WorkerCategoryConfig {
  key: string;
  label: string;
}

/**
 * 재해발생 현황 (연도별)
 * 원본 양식 기준: 계, 사망, 부상, 직업병, 재해율
 */
export interface AccidentStatsEntry {
  id?: string;                   // DB PK (서버 응답에 포함)
  periodValue: string;           // "2025", "2026"
  workerCount: number;           // 해당 연도 근로자 수
  deathCount: number;
  injuryCount: number;
  diseaseCount: number;
  accidentRate?: number;         // 재해율 (%)
}

/** 안전관리상태보고서 근로자 카테고리 (사무직 / 사무직외) */
export const SMS_WORKER_CATEGORIES: WorkerCategoryConfig[] = [
  { key: 'office', label: '사무직' },
  { key: 'nonOffice', label: '사무직외' },
];

/** 재해발생 현황 카운트 필드 (사망/부상/직업병) */
export const ACCIDENT_COUNT_FIELDS: {
  key: 'deathCount' | 'injuryCount' | 'diseaseCount';
  label: string;
}[] = [
  { key: 'deathCount', label: '사망' },
  { key: 'injuryCount', label: '부상' },
  { key: 'diseaseCount', label: '직업병' },
];

/** 빈 근로자 현황 엔트리 생성 (카테고리 count 0) */
export function createEmptyWorkerEntry(periodValue: string): WorkerStatsEntry {
  return {
    periodValue,
    categories: SMS_WORKER_CATEGORIES.map((c) => ({ key: c.key, count: 0 })),
  };
}

/** 빈 재해발생 현황 엔트리 생성 (workerCount 포함) */
export function createEmptyAccidentEntry(
  periodValue: string,
): AccidentStatsEntry {
  return {
    periodValue,
    workerCount: 0,
    deathCount: 0,
    injuryCount: 0,
    diseaseCount: 0,
  };
}
